/* script */
//
//
//

// Utils
import { isEmpty, get } from 'lodash';

/**
 * This is the base wizard step interface.
 *
 * @vue-prop {Object} params extra parameters object to be extending components.
 *
 * @category ui.components
 * @exports WizardStep
 * @component
 */
const __vue_script__ = {
    name: 'WizardStep',

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            valid: false,
            form: {},
            focus: null,
            initialized: false
        };
    },

    watch: {
        valid() {
            this.$emit('validity', this.valid);
        }
    },

    created() {
        this.importDataFromPreviousSteps();
    },

    activated() {
        this.importDataFromPreviousSteps();
    },

    deactivated() {
        this.focus = null;
    },

    methods: {
        /**
         * Merges any previous wizard step into the current form.
         */
        importDataFromPreviousSteps() {
            for (const field of Object.keys(this.params.form || {})) {
                if (!this.form.hasOwnProperty(field) || isEmpty(this.form.field)) {
                    // We use `$set` to trigger a UI update
                    this.$set(this.form, field, this.params.form[field]);
                }
            }

            this.focus = this.params.focus;

            if (!this.initialized) {
                this.initialized = true;
                // We add the watcher programmatically because of the `$set`.
                // If we add the watcher before it will trigger too many UI digests.
                this.$watch('form', () => this.validate(true), { deep: true });
            }
        },

        /**
         * Ask the wizard to navigate to the specified step.
         *
         * @param {Number} stepNumber the step number to go to
         * @param {String} [field] an optional field to focus
         */
        toStep(stepNumber, field) {
            this.$emit('step:go', stepNumber, field);
        },

        /**
         * Must return inner form validity
         *
         * @param {Boolean} [silent=false] whether to trigger the normal validation or the silent one
         *
         * @returns {Promise.<Boolean>} the form validity
         */
        async validate(silent = false) {
            const form = this.$refs.form;
            const fields = get(form, 'fields', {});

            this.valid = !form
                || await form.validate({ silent })
                || Object.keys(fields).length === 0;

            return this.valid;
        },

        /**
         * Default form submission
         *
         * @returns {Promise.<Boolean>} submission status
         */
        submit() {
            return this.validate();
        },

        /**
         * Gets the correct template name
         *
         * @param {Object} workspace the template to get the title of
         *
         * @return {String} the template name
         */
        getWorkspaceName(workspace) {
            return this.$utils.workspaces.getWorkspaceTitle(workspace, this.$i18n.locale);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard-step"})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WizardStep.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__